import { NativeHelper } from '@web/data/native.helper';
import { FlashWrapper } from '@web/atomic/legacy/obj.flash-wrapper/flash-wrapper.component';
import { messengerExtensionSdkUrl } from '@web/data/messenger-user-info.datasource';
import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

interface WebviewLayoutProps {
  children: ReactNode;
  hideThemeChanger?: boolean;
  skipMessengerExtensionLoad?: boolean;
}

const WebviewLayout: React.FunctionComponent<WebviewLayoutProps> = ({ children }) => {
  return (
    <>
      {NativeHelper.isNative || (
        <Helmet>
          <script src={messengerExtensionSdkUrl} async />
        </Helmet>
      )}
      <FlashWrapper />
      {children}
    </>
  );
};

export default WebviewLayout;
